import React from "react";
import { Divider } from "@mui/material";


const SettingDivider = () => {
  return <Divider sx={{mt: 1, mb: 1}} />
}

export default SettingDivider;